import { Image, Modal } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { useImageAttachmentActions } from '../../../resource/resources/artifacts/attachment/imageAttachmentResource';

export const ImageContentDisplay= ({imageAttachmentObjectId, versionedIn, height}: {
    imageAttachmentObjectId: string;
    versionedIn: string;
    height: number | null
}) => {
    const imageAttachmentActions = useImageAttachmentActions()

    const imageAttachmentQuery = imageAttachmentActions.useGetResourceByObjectIdAndVersionedIn(imageAttachmentObjectId, versionedIn)

    const [opened, { open, close }] = useDisclosure(false);

    const getExtension = () => {
        const split = imageAttachmentQuery.data?.fileName?.split(".")
        if (!split) {
            return ""
        }
        const splitLength = split.length
        return split[splitLength - 1]
    }

    if (imageAttachmentQuery.data) {
        const source = `data:image/${getExtension()};base64,${imageAttachmentQuery.data.fileContent}`
        return <>
            <Modal opened={opened} onClose={close} title="Authentication" fullScreen={true} centered={true}  styles={{  body: {  height: "90%" }}}>
                <div style={{display: "flex", justifyContent: "center", alignItems: "center", height: "100%", width: "100%"}}>
                    <Image
                        w="auto"
                        fit="contain"
                        src={source}
                    />
                </div>

            </Modal>
            <Image
                onClick={open}
                height={height ?? undefined}
                fit="contain"
                src={source}
            />
        </>

    }
    return <div></div>
};
